import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { BookingItem } from './booking-item'
import { bookingItemActions } from './booking-item.actions'
import * as fromParticipation from './booking-item.reducer'
import { BookingItemService } from './booking-item.service'
import { persistentUserRoleActions } from '../../role/user-role/persistent-user-role/persistent-user-role.actions'
import { switchMap, take, tap } from 'rxjs/operators'
import { of } from 'rxjs'
import { persistentUserRoleSelectors } from '../../role/user-role/persistent-user-role/persistent-user-role.selector'

@Injectable()
export class BookingItemEffects extends ResourceEffects<BookingItem> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public bookingBookingItemService: BookingItemService,
    public router: Router
  ) {
    super(
      fromParticipation.FEATURE_NAME,
      bookingBookingItemService,
      bookingItemActions,
      actions$
    )
  }
  onSetSelectedUserRole = createEffect(
    () =>
      this.actions$.pipe(
        ofType(persistentUserRoleActions.setSelectedUserRole),
        tap((action) => {
          let userRole:any
          this.store.select(persistentUserRoleSelectors.selectSelectedUserRole).pipe(
            take(1)
            ).subscribe((user)=>{
              userRole=user
            })
            userRole&&this.store.dispatch(bookingItemActions.resetState())})
      ),
    { dispatch: false }
  )
}
